/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import NextLink from '../NextLink';
import { colors } from '../../constants/styleConstants';
import { route } from '../../constants/routes';
import { getRouteWithSlug } from '../../utils/common';
import { EMPTY_INFO_MARK } from '../../constants/consts';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '5px 0',
    flexWrap: 'nowrap',
  },
  profession: {
    fontWeight: 'bold',
    flexGrow: props => (props.short ? 1 : 2),
    flexWrap: 'nowrap',
    lineHeight: 1.2,
    textAlign: 'end',
    [theme.breakpoints.down('xs')]: {
      flexGrow: '2 !important',
    },
  },
  name: {
    flexGrow: 2,
    lineHeight: 1.3,
    [theme.breakpoints.down('xs')]: {
      flexGrow: 3,
    },
  },
  nameItem: {
    lineHeight: 1.2,
  },
  linkItem: {
    lineHeight: 1.2,
  },
  qualification: {
    marginLeft: 5,
    lineHeight: 1.3,
  },
  nameWrapper: {
    lineHeight: 1.2,
    '&::before': {
      content: "'/'",
      padding: '0 3px',
      color: colors.subTitle,
    },
    '&:first-of-type::before': {
      display: 'none',
    },
  },
  role: {
    fontSize: '12px',
    lineHeight: 1.3,
    display: 'flex',
    color: colors.cardTitle,
    fontWeight: 'normal',
    flexBasis: 'auto',
    justifyContent: 'flex-start',
    marginLeft: 5,
    marginTop: '2px',
  },
  roleName: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
    lineHeight: 1.2,
  },
}));

const CastRow = props => {
  const { castGroupByRole, showText } = props;
  const classes = useStyles(props);
  return (
    <>
      {castGroupByRole &&
        Object.keys(castGroupByRole || {}).map((key, keyMember) => {
          const isRenderCast = castGroupByRole[key].some(item => item?.profile || item?.profileReference);

          return (
            <div key={keyMember}>
              {isRenderCast && (
                <Grid item container direction="row" spacing={1} className={classes.container}>
                  <Grid item xs={6} className={classes.profession}>
                    <span className={classes.roleName}>{key === 'null' ? '~' : key}</span>
                  </Grid>
                  <Grid item xs={6} className={classes.name}>
                    {castGroupByRole[key]?.length > 0
                      ? castGroupByRole[key].map((item, member) => {
                          const theProfile = get(item, 'profile');
                          const linkProps = {
                            href: `${route.ARTISTS}/[id]/[[...action]]`,
                            as: getRouteWithSlug(route.ARTISTS, get(item, 'profile')),
                            target: '_blank',
                          };
                          return (
                            <span key={member} className={classes.nameWrapper}>
                              {linkProps &&
                              theProfile &&
                              (item.profile || item.profileReference) &&
                              !showText &&
                              !theProfile.is_hidden ? (
                                <NextLink {...linkProps} className={classes.linkItem}>
                                  <span className={classes.nameItem}>
                                    {item.profile ? item.profile.name : item.profileReference}
                                  </span>
                                </NextLink>
                              ) : (
                                <>
                                  {(item.profile || item.profileReference || theProfile?.is_hidden) && (
                                    <span className={classes.nameItem}>
                                      {item.profile ? item.profile.name : item.profileReference}
                                    </span>
                                  )}
                                </>
                              )}
                            </span>
                          );
                        })
                      : EMPTY_INFO_MARK}
                  </Grid>
                </Grid>
              )}
            </div>
          );
        })}
    </>
  );
};

CastRow.propTypes = {
  castGroupByRole: PropTypes.object,
  showText: PropTypes.bool,
};

CastRow.defaultProps = {
  showText: false,
};

export default CastRow;
